import { render } from "./SpacingDemo.vue?vue&type=template&id=0195f625&scoped=true"
import script from "./SpacingDemo.vue?vue&type=script&lang=js"
export * from "./SpacingDemo.vue?vue&type=script&lang=js"

import "./SpacingDemo.vue?vue&type=style&index=0&id=0195f625&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0195f625"]])

export default __exports__